import {
  NavigateBefore as PrevIcon,
  NavigateNext as NextIcon,
} from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const PaginationControls = ({
  paginationRef,
  startRow,
  endRow,
  totalRows,
  onPrevPage,
  onNextPage,
}) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const isFirstPage = startRow <= 1;
  const isLastPage = endRow >= totalRows;
  return (
    <Box
      ref={paginationRef}
      sx={{
        display: "flex",
        width: "fit-content",
        alignSelf: "flex-end",
        alignItems: "center",
        justifyContent: "flex-end",
        pl: 2,
        pr: 1,
        py: 1,
        mt: "auto",
        flexShrink: 0,
        backgroundColor: "background.paper",
        zIndex: 1000,
        borderRadius: 2,
      }}
    >
      <Typography
        variant={"body2"}
        color={"text.secondary"}
      >{`${startRow}–${endRow} of ${totalRows}`}</Typography>
      <IconButton
        onClick={onPrevPage}
        disabled={isFirstPage}
        size={"small"}
        aria-label={translateLabels(labels.PAGINATION_PREVIOUS_PAGE, {
          default: "Previous page",
        })}
      >
        <PrevIcon />
      </IconButton>
      <IconButton
        onClick={onNextPage}
        disabled={isLastPage}
        size={"small"}
        aria-label={translateLabels(labels.PAGINATION_NEXT_PAGE, {
          default: "Next page",
        })}
      >
        <NextIcon />
      </IconButton>
    </Box>
  );
};
export default PaginationControls;
